import { Recommendation } from '@/types/Ella';

const fallbackRecommendations: Pick<
  Recommendation,
  'id' | 'store' | 'name' | 'mainImage' | 'price' | 'cj_link'
>[] = [
  {
    id: 'f0e32bb4-9570-573a-b2d8-71d663b4c8bb',
    name: 'SNDYS x REVOLVE Novalie Top in Red.',
    mainImage: 'https://is4.revolveassets.com/images/p4/n/d/SDYS-WS148_V1.jpg',
    price: '60',
    store: 'revolve'
  },
  {
    id: '7a75cb7f-fb3a-5a5e-9e59-fc902bb5620f',
    name: 'RE/DONE Little Devil Graphic Tee in White.',
    mainImage: 'https://is4.revolveassets.com/images/p4/n/d/REDR-WS9_V1.jpg',
    price: '160',
    store: 'revolve'
  },
  {
    id: '730358c3-45a2-58c6-b95a-73786c687821',
    name: 'SNDYS X Revolve Lia Longline Cardigan in Black.',
    mainImage: 'https://is4.revolveassets.com/images/p4/n/d/SDYS-WK57_V1.jpg',
    price: '117',
    store: 'revolve'
  },
  {
    id: 'af5f79cc-6150-5376-a270-5b65670cdf02',
    name: 'RE/DONE Ribbed Polo Cardigan in Lavender',
    mainImage: 'https://is4.fwrdassets.com/images/p/fw/z/REDR-WS268_V1.jpg',
    price: '395',
    store: 'FWRD'
  },
  {
    id: '673b4fad-4b27-5af4-9c72-c73f00863408',
    name: 'Rue Sophie Triomphe Top in Black.',
    mainImage: 'https://is4.revolveassets.com/images/p4/n/d/SRUE-WS8_V1.jpg',
    price: '108',
    store: 'revolve'
  },
  {
    id: 'b57d9e6c-12e6-511c-825c-8fafff5eb6ff',
    name: 'RE/DONE x Hanes Ribbed Tank in White.',
    mainImage: 'https://is4.revolveassets.com/images/p4/n/d/REDR-WS21_V1.jpg',
    price: '95',
    store: 'revolve'
  },
  {
    id: 'd95f1cd2-9bc2-5059-b464-a58d604ee87b',
    name: 'REVOLVE X Rand Cai Jacket in Blue.',
    mainImage: 'https://is4.revolveassets.com/images/p4/n/d/RVLV-WO15_V1.jpg',
    price: '498',
    store: 'revolve'
  },
  {
    id: '487a688a-9247-5d06-aaa7-0b4f5454270c',
    name: 'Abrand Venice Short in Blue.',
    mainImage: 'https://is4.revolveassets.com/images/p4/n/d/ABRR-WF8_V1.jpg',
    price: '88',
    store: 'revolve'
  }
];

export default fallbackRecommendations;
